import type { CSSObject, MantineNumberSize } from '@mantine/core';

import { fontSizeLineHeights, fontSizes } from '../../consts';

export const getFontSizeStyles = (size: MantineNumberSize): CSSObject => ({
  fontSize: fontSizes[size],
  lineHeight: fontSizeLineHeights[size],
});
